import { MinusCircleOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Checkbox, Col, Form, InputNumber, Row, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../../../contextRedux/DeviceType/DeviceTypeModel';
import {
  addWorkPlaceItems,
  removeWorkPlaceItems,
  updateWorkPlaceItems,
} from '../../../../../contextRedux/WorkPlace/WorkPlaceModel';
import DeviceModal from '../../../../../pages/DeviceType/DeviceModal/DeviceModal';
import { RootState } from '../../../../../store';

const DeviceTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const addRef = useRef<(defaultValue?: any) => void>();

  //const deviceType = useSelector((state: RootState) => state?.models?.deviceType);
  const workPlaceId = useSelector((state: RootState) => state?.models?.workPlace?.id) ?? '';
  const systems = useSelector((state: RootState) => state?.store?.systemType?.data || []);
  const devices = useSelector((state: RootState) => state?.store?.deviceType?.data || []);
  const [filterDevices, setFilterDevices] = useState<any>([]);
  const initialValues = useSelector((state: RootState) => state?.models?.workPlace?.workPlaceItems || []);

  useEffect(() => {
    form.setFieldsValue({ workPlaceItems: Array.isArray(initialValues) ? initialValues : [] });
  }, [initialValues, form]);

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().includes(inputValue.toLowerCase());
  };

  const handleAddWorkPlaceItem = (addFn: any) => {
    const newWorkPlaceItem = {
      id: '',
      workPlaceId,
      systemTypeId: '',
      deviceTypeId: '',
      piece: 1,
      isAnotherProvider: false,
      systemType: null,
      deviceType: null,
    };

    addFn(newWorkPlaceItem);
    dispatch(addWorkPlaceItems(newWorkPlaceItem));
  };

  const handleRemoveWorkPlaceItem = (index: number, removeFn: any) => {
    removeFn(index);
    dispatch(removeWorkPlaceItems(index));
  };

  const updateWorkPlaceItemProperty = (index: number, updates: Partial<any>) => {
    const updatedWorkPlaceItems = form.getFieldValue('workPlaceItems') || [];
    updatedWorkPlaceItems[index] = { ...updatedWorkPlaceItems[index], ...updates };
    form.setFieldsValue({ workPlaceItems: updatedWorkPlaceItems });
    dispatch(updateWorkPlaceItems({ index, updates }));
  };

  const handleSelectSystemType = (value: any, index: number): void => {
    const systemType = systems.find((a: any) => a?.name === value);
    if (systemType) {
      setFilterDevices(devices.filter((d) => d?.systemTypeId === systemType?.id));
      updateWorkPlaceItemProperty(index, {
        systemTypeId: systemType?.id,
        systemType,
        deviceTypeId: '',
        deviceType: null,
      });
    }
  };

  const handleSelectDeviceType = (value: any, index: number): void => {
    const deviceType = devices.find((a: any) => a?.name === value);
    if (deviceType) {
      updateWorkPlaceItemProperty(index, {
        deviceTypeId: deviceType?.id,
        deviceType,
      });
    }
  };

  const handleAddNewDevice = () => {
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  return (
    <Form
      form={form}
      name='deviceTabForm'
      initialValues={{ workPlaceItems: initialValues }}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Form.List name='workPlaceItems'>
        {(fields, { add, remove }) => {
          addRef.current = add;
          return (
            <>
              {fields.map((field, index) => (
                <Row gutter={16} align='middle' key={field.key} style={{ justifyContent: 'space-between' }}>
                  <Col xs={24} sm={12} md={8} lg={4}>
                    <Form.Item
                      {...field}
                      label='Sistem'
                      name={[field.name, 'systemType', 'name']}
                      rules={[{ required: true, message: 'Selectează un sistem!' }]}
                    >
                      <AutoComplete
                        onSelect={(value: any) => handleSelectSystemType(value, index)}
                        filterOption={handleFilter}
                        placeholder='Alege un sistem'
                      >
                        {systems.map((system: any) => (
                          <Option key={system.id} value={system.name}>
                            {system.name}
                          </Option>
                        ))}
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      {...field}
                      label='Device'
                      name={[field.name, 'deviceType', 'name']}
                      rules={[{ required: true, message: 'Selectează un device!' }]}
                    >
                      <AutoComplete
                        onSelect={(value: any) => handleSelectDeviceType(value, index)}
                        filterOption={handleFilter}
                        placeholder='Alege un device'
                      >
                        {filterDevices?.map((device: any) => (
                          <Option key={device.id} value={device.name}>
                            {device.name}
                          </Option>
                        ))}
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={4}>
                    <Form.Item
                      {...field}
                      label='Bucăți'
                      name={[field.name, 'piece']}
                      rules={[{ required: true, message: 'Selectează numărul de bucăți!' }]}
                    >
                      <InputNumber
                        min={1}
                        onChange={(value) => updateWorkPlaceItemProperty(index, { piece: value })}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={4}>
                    <Form.Item
                      {...field}
                      label='Alt furnizor'
                      name={[field.name, 'isAnotherProvider']}
                      valuePropName='checked'
                    >
                      <Checkbox
                        onChange={(e) => updateWorkPlaceItemProperty(index, { isAnotherProvider: e.target.checked })}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={4}>
                    <Button
                      type='link'
                      icon={<MinusCircleOutlined />}
                      onClick={() => handleRemoveWorkPlaceItem(index, remove)}
                    />
                  </Col>
                </Row>
              ))}
              <Form.Item>
                <Button type='dashed' onClick={() => handleAddWorkPlaceItem(add)} style={{ width: '100%' }}>
                  Adaugă un device existent
                </Button>
              </Form.Item>
              <Form.Item>
                <Button type='dashed' onClick={() => handleAddNewDevice()} style={{ width: '100%' }}>
                  Adaugă un device nou
                </Button>
              </Form.Item>
            </>
          );
        }}
      </Form.List>

      <DeviceModal></DeviceModal>
    </Form>
  );
};

export default DeviceTab;
